import api from '@config/api'
import { useQuery } from 'react-query'
import { useQueryConfig } from './useQueryConfig'
import {
    IRequestDeleteContactByIdList,
    IRequestDeleteContactById,
    IRequestFindContact,
    IResponseFindContact,
    ContactID,
} from '@apiinterface/IContact'
import { IFormMutationHandlerProps } from '@interfaces/default/IDefault'
import { useFormMutationHandler } from '@utils/useFormMutationHandler'

interface IUseDeleteContactById
    extends ContactID,
        IFormMutationHandlerProps<IRequestDeleteContactById> {}

interface IUseBulkDeleteContact
    extends IFormMutationHandlerProps<IRequestDeleteContactByIdList> {}

const Contact = {
    useFindContact: ({
        limit = 100,
        orderby = 'quiz_id',
        order = 'desc',
        page = 1,
        search = '',
        created_at,
        topic = '',
    }: IRequestFindContact) => {
        return useQuery(
            'findContact',
            async () => {
                try {
                    const res = await api.get('/contact', {
                        params: {
                            limit,
                            orderby,
                            order,
                            page,
                            search,
                            created_at,
                            topic,
                        },
                    })
                    return res.data.body as IResponseFindContact
                } catch (error) {
                    return Promise.reject(error)
                }
            },
            useQueryConfig
        )
    },
    useDeleteContactById: ({ id, aftersuccess }: IUseDeleteContactById) => {
        return useFormMutationHandler({
            pathWithMethod: [`/contact/${id}`, 'delete'],
            aftersuccess,
        })
    },
    useBulkDeleteContact: ({ aftersuccess, form }: IUseBulkDeleteContact) => {
        return useFormMutationHandler({
            pathWithMethod: [`/contact`, 'delete'],
            aftersuccess,
            form,
        })
    },
}

export default Contact
